module.exports = __webpack_public_path__ + "static/media/m-headshot-cynthia.db3b78a5.png";